import {Box, Button, IconButton,  Modal,  styled} from "@mui/material";
import React, {useState} from "react";
import ArticleIcon from "@mui/icons-material/Article";
import DownloadIcon from "@mui/icons-material/Download";
import OpenInFullIcon from "@mui/icons-material/OpenInFull";
import CloseIcon from "@mui/icons-material/Close";

interface FileButtonInterface {
    title: string;
    file: string;
    fileTitle: string;
    filePdf: string;
    size?: string;
    noRightSpace?: boolean;
}

const FileButtonContainer = styled(Box)({
    position: "relative",
    display: "flex",
    justifyContent: "center",
});

const TopSectionButton = styled(Button)({
    position: "relative",
    zIndex: 2,
    cursor: "pointer",
    textTransform: "none",
    display: "flex",
    gap: "10px",
    background: "linear-gradient(90deg,#df5b4f,#72313d)",
    borderRadius: "50px",
    padding: "15px 40px",
    fontWeight: 800,
    color: "#FFF",
    fontSize: "1.6rem",
    transition: "background 0.5s cubic-bezier(0.68, -0.55, 0.265, 1.55), transform 0.5s ease-out",
    "&:hover":{
        background: "linear-gradient(45deg, #ffc371, #ff5f6d)",
        boxShadow:"0 0 15px #ffc371",
        transform: "scale(1.05)",
    },
    "&.noRightSpace":{
        transform: "translateX(-55px)",
    },
    "&.small":{
        fontSize: "1rem",
    },
    "&.openDownloadButton": {
        transform: "translateX(-25%)",
        "&.noRightSpace":{
            transform: "translateX(-155px)",
        },
    },
    "@media(max-width: 768px)":{
        fontSize: ".8rem",
        "&.small":{
            margin: "auto"
        },
    }
});

const DownloadButton = styled(TopSectionButton)({
    position: "absolute",
    height: "100%",
    zIndex: 1,
    borderRadius: "0 50px 50px 0",
    paddingRight: "25px",
    paddingLeft: "45px",
    transform: "translateX(-20px)",
    "&:hover":{
        transform: "scale(1)",
    },
    "&.openDownloadButton": {
        transform: "translateX(80px)",
        "@media(max-width: 768px)":{
            transform: "translateX(60%)",
        },
        "&.noRightSpace":{
            transform: "translateX(-35px)",
        },
    }
});

const SeeButton = styled(TopSectionButton)({
    position: "absolute",
    height: "100%",
    zIndex: 0,
    borderRadius: "0 50px 50px 0",
    paddingRight: "25px",
    paddingLeft: "35px",
    transform: "translateX(0)",
    "&:hover":{
        transform: "scale(1)",
    },
    "&.openDownloadButton": {
        transform: "translateX(140px)",
        "@media(max-width: 768px)":{
            transform: "translateX(145%)",
        },
        "&.noRightSpace":{
            transform: "translateX(20px)",
        },
    }
});

const FileModalContainer = styled(Box)({
    background: "#020508",
    height: "100vh",
    width: "100vw",
    "& button":{
        padding: "10px",
        marginLeft: "calc(100% - 45px)"
    }
});

const FileButton = ({title, size,noRightSpace, fileTitle, file, filePdf}: FileButtonInterface):JSX.Element => {
    
    const [open, setOpen] = useState<boolean>(false);
    const [openModal, setOpenModal] = useState<boolean>(false);
    
    const toggleOpen = (): void => {
        setOpen(!open);
    };
    
    const onOpenFileModal = (): void => {
        toggleOpen();
        setOpenModal(true);
    };
    
    const onCloseFileModal = (): void => {
        setOpenModal(false);
    };
    
    const onDownload = (): void => {
        toggleOpen();
        const anchor = document.createElement("a");
        anchor.href = file;
        anchor.download = fileTitle;
        document.body.appendChild(anchor);
        anchor.click();
        document.body.removeChild(anchor);
    };
    
    return (
        <FileButtonContainer>
            <TopSectionButton onClick={toggleOpen} className={`${open ? "openDownloadButton" : ""} ${size || ""} ${noRightSpace ? "noRightSpace" : ""}`}>
                <ArticleIcon htmlColor={"#FFFFFF"}/>
                {title}
            </TopSectionButton>
            <DownloadButton onClick={onDownload} className={`${open ? "openDownloadButton" : ""} ${noRightSpace ? "noRightSpace" : ""}`}>
                <DownloadIcon htmlColor={"#FFFFFF"}/>
            </DownloadButton>
            <SeeButton onClick={onOpenFileModal} className={`${open ? "openDownloadButton" : ""} ${noRightSpace ? "noRightSpace" : ""}`}>
                <OpenInFullIcon htmlColor={"#FFFFFF"}/>
            </SeeButton>
            <Modal open={openModal} onClose={onCloseFileModal}>
                <FileModalContainer>
                    <IconButton onClick={onCloseFileModal}>
                        <CloseIcon htmlColor={"#FFFFFF"}/>
                    </IconButton>
                    <iframe
                        src={filePdf}
                        width="100%"
                        height="100%"
                        style={{
                            border: "none"
                        }}
                    />
                </FileModalContainer>
            </Modal>
        </FileButtonContainer>
    );
};

export default FileButton;
